import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import { SubL3CategoriesStyled } from './SubL3CategoriesStyled';
import { PRODUCT_CARD_DEFAULT } from '../../../Assets/images';
import { ONLINE_PHARMACY_ROUTE } from '../../../Utility/constants';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getLangCodeFromUrl } from '../../../../../i18n';
import { isRTL } from '@common/i18n';

const SubL3Categories = ({ subL3category, name, shopByBrand, showFullWidth, pageType, screenName }) => {
  const generateURL = useNavigationURL();
  const [currentLang, setCurrentLanguage] = useState('');
  useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);
  
  return (
  <SubL3CategoriesStyled
    width={showFullWidth}
    className={currentLang && isRTL(currentLang) ? 'rtl' : ''}
  >

    <div className="containerL3">
      <div className="categorySection">
        {!showFullWidth && <div className="l3Title">{name}</div>}
        <div className="categoriesDetails">
          {subL3category?.map((element) => (
            <div className="carouselContainer" key={element?.id}>
              <div className="catImage">
                <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/c/${element?.name?.toLowerCase()?.replace(/ /g, '-')?.replace(/[^a-zA-Z0-9-]/g, '-')?.replace(/-{2,}/g, '-')}/${element?.id}`)} passHref>
                  <a>
                    <Image src={getImageUrlWithSize(element?.image, 60, 60) || PRODUCT_CARD_DEFAULT.src} height={60} width={60} unoptimized/>
                  </a>
                </Link>
              </div>
              <div className="catTitle"> {element?.name} </div>
            </div>
          ))}
        </div>
      </div>
      {shopByBrand?.length > 0 && (
        
        <div className="brandSection">
          <div className="brandTitle">Featured Brands</div>
          <div className="brandDetails">
            {shopByBrand?.map((item, index) => (
              <div className="brandCarousel" key={item?.brandId}>
                
                <div className="catImage">
                  <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/${item?.brandUrl}`)} passHref>
                    <a>
                      <Image
                        src={getImageUrlWithSize(item?.image, 75, 39) || PRODUCT_CARD_DEFAULT.src}
                        height={39}
                        width={75}
                        onClick={() => {
                          dataLayerSendEvent('brand_item_clicked', {
                            brand_name: item?.title,
                            brand_id: item?.id,
                            position: index+1,
                            section_name: 'brand_static_menu',
                            myaster_category: 'epharmacy',
                            page_type: pageType,
                            screen_name: screenName,
                          });
                        }}
                        unoptimized
                      />
                    </a>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </SubL3CategoriesStyled>
)};
SubL3Categories.propTypes = {
  subL3category: PropTypes.object,
  shopByBrand: PropTypes.array,
  name: PropTypes.string,
  showFullWidth: PropTypes.bool,
};

SubL3Categories.defaultProps = {
  subL3category: {},
  shopByBrand: [],
  name: '',
  showFullWidth: false,
};
export default SubL3Categories;
